import { combineReducers } from 'redux'

// import filtroAplicados from "./filtroAplicados"

import filtroAplicados from './filtroAplicados'
import resultados from './detalhesMetasEducacaoEmpenho'

export default combineReducers({ filtroAplicados, resultados })
